export default __webpack_public_path__ + "css/customerUploads.bundle.css";